import { useMutation } from 'libs/query'
import { useContext } from 'react'
import axios from 'libs/fetch'
import { AuthContext } from 'store/AuthContext'
import { useNavigate } from 'react-router-dom'
import { FieldValues, UseFormSetError } from 'libs/form'
import { localStorageKeys } from 'config/localStorage/localStorageKeys'

export const useLoginMutation = (setError: UseFormSetError<FieldValues>) => {
	const { setAuth } = useContext(AuthContext)
	const navigate = useNavigate()

	const { mutate: loginMutation, isPending: loadingLogin } = useMutation({
		mutationFn: (data: any) => axios.post('/login/', data),
		onSuccess: (res) => {
			localStorage.setItem('refresh', res.data.refresh)

			setAuth((prev: any) => ({ ...prev, accessToken: res.data.access }))
			localStorage.setItem(localStorageKeys.showBankToast, 'true')
			navigate('/')
		},
		onError: (data: any) => {
			const errorMessage = data.response.data.detail

			setError('password', { type: 'custom', message: errorMessage })
		}
	})

	return {
		loginMutation,
		loadingLogin
	}
}
